/* eslint-disable max-len */
import React, { useEffect } from 'react';
import {
  CContainer,
  CButton,
} from '@coreui/react';
import { CIcon } from '@coreui/icons-react';
import { cilPlus } from '@coreui/icons';
import { useNavigate } from 'react-router-dom';
import StockStatusTable from '../../components/StockStatusTable/StockStatusTable'; // StockStatusTable componenti oluşturulacak
import {
  getStockStatusRequestAction,
  sortStockStatusHistorySortData,
  sortingStockStatusHistoryAction,
} from '../../store/stockStatus/stockStatusActions'; // Stock ile ilgili aksiyonlar
import { connect } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import './StockStatus.scss';

const StockStatus = (props) => {
  const {
    stockStatusHistorySortData,
    setSortData,
    sortingStockStatusHistory,
    stockStatusData,
    stockStatusList,
    getStockStatusRequest,
    user,
  } = props;

  const navigate = useNavigate();
  const { t } = useTranslation();

 useEffect(() => {
  getStockStatusRequest({ });
}, []);

  useEffect(() => {
    if (stockStatusHistorySortData) {
      getStockStatusRequest({
        StockStatusId: null
      });
    }
  }, [stockStatusHistorySortData]);

  function changeSortType(sortType) {
    const newstockStatusHistorySortData = { ...stockStatusHistorySortData, sortType };
    setSortData(newstockStatusHistorySortData);
    sortingStockStatusHistory();
  }

  function changeSortKey(sortKey) {
    const newstockStatusHistorySortData = { ...stockStatusHistorySortData, sortKey };
    setSortData(newstockStatusHistorySortData);
    sortingStockStatusHistory();
  }

  const handleCreateStock = () => {
    navigate('/stock-status/create');
  };

  return (
    <div className="stock-status-page-container">
      <CContainer>
        <div className="text-fs-head-sm text-start mb-3">{t('Stock Status')}</div>
        
        <StockStatusTable 
          changeSortType={changeSortType}
          changeSortKey={changeSortKey}
          stockStatusHistorySortData={stockStatusHistorySortData}
          stockStatusList={stockStatusList}
          stockStatusData={stockStatusData}
        />
      </CContainer>

      <CButton
        color="primary"
        className="create-stock-status-fab"
        onClick={handleCreateStock}
        title={t('Create New Stock')}
      >
        <CIcon icon={cilPlus} size="lg" />
      </CButton>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    stockStatusData: state.stockStatusReducer.stockStatusData,
    stockStatusList: state.stockStatusReducer.stockStatusList,
    stockStatusHistorySortData: state.stockStatusReducer.stockStatusHistorySortData,
    isLoading: state.loadingReducer.isLoading,
    user: state.userReducer.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSortData: (payload) => {
      dispatch(sortStockStatusHistorySortData(payload));
    },
    sortingStockStatusHistory: (payload) => {
      dispatch(sortingStockStatusHistoryAction(payload));
    },
    getStockStatusRequest: (payload) => {
      dispatch(getStockStatusRequestAction(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StockStatus);
